// side effect: fetch new lightProfile simulation when decisions are made
import {fetchProfileResult, setProfile, resetCustomUpload, setLuminaryId} from './lightProfileSlice';
import buildConfiguration from './profiles';
import {selectProfileId, selectSpcSession} from '../selectors';
import {luminaryOptions} from './lightProfileSectionConfig';
import {setStatus, setMode} from '../slices/statusSlice';
import {lightProfileToFeatureValueMap, regionToFeatureValueMap} from './lightProfiles';
import {spcExpliciteChoiceDecision} from '../util/values';
import {saveLightProfileDailySegments, storeConfiguration} from '../slices/configurationSlice';
import {closeSpcSession} from '../slices/spcSlice';
import {fetchShortNumber} from '../slices/shortNumberSlice';

export const lightProfileMiddleware = store => next => async action => {
	const result = next(action);

	if (store.getState().status.family !== 'LightProfile') return result;

	// console.log('lightProfileMiddleware', action.type, store.getState().status.family, store.getState().status.dataKey);
	if (
		action.type === 'lightProfile/fetchLightProfileLocation/fulfilled' ||
		action.type === 'lightProfile/setBaseProfileId' ||
		action.type === 'lightProfile/setZoneId' ||
		action.type === 'lightProfile/setCentralPowerControlId' ||
		action.type === 'lightProfile/setLuminaryId' ||
		action.type === 'lightProfile/setProjectName' ||
		action.type === 'lightProfile/setPicoPassword'
	) {
		if (store.getState().status.dataKey) {
			store.dispatch(storeConfiguration());
		}
	}

	if (action.type === 'lightProfile/setBaseProfileId' || action.type === 'lightProfile/setZoneId' || action.type === 'lightProfile/fetchLightProfileLocation/fulfilled' || action.type === 'lightProfile/setProfileData' || action.type === 'lightProfile/setCentralPowerControlId') {

		const lightProfile = store.getState().lightProfile.data;
		if (lightProfile.project?.base !== null && lightProfile.project?.zone !== null && lightProfile.project?.centralPowerControl !== null) {
			const profileId = selectProfileId(store.getState());
			//get the new lightProfile simulation
			if (profileId && lightProfile.project.location !== null && lightProfile.project.location.latitude !== null && lightProfile.project.location.longitude !== null) {
				const profile = buildConfiguration(
					profileId,
					lightProfile.project.location.latitude,
					lightProfile.project.location.longitude,
					lightProfile.project.location.timezoneName,
					lightProfile.project.location.offset,
				);
				store.dispatch(setProfile(
					{
						profile: Object.assign({}, profile)
					}
				));
				store.dispatch(
					fetchProfileResult(profile)
				);

				if (lightProfile.project.luminary !== null && store.getState().productData.models.length === 0) {
					const lo = luminaryOptions.find(o => o.id === lightProfile.project.luminary);
					await store.dispatch(
						setStatus({
							productFamily: lo.family
						})
					);
					await store.dispatch(
						setMode({mode: 'external'})
					);

				}


				const base = store.getState().lightProfile.data.project?.base;
				const zone = store.getState().lightProfile.data.project?.zone;
				console.log('lightProfileMiddleware', base, zone);
				// get the new shortArticleNumbers, when lightProfile is selected
				if (base && zone) {

					const data = JSON.stringify(
						{
							configurationData: {
								lightProfileData: {
									base: store.getState().lightProfile.data.project.base,
									zone: store.getState().lightProfile.data.project.base,
									latitude: store.getState().lightProfile.data.project.location.latitude,
									longitude: store.getState().lightProfile.data.project.location.longitude,
									locationName: store.getState().lightProfile.data.project.location.name,
									timezoneName: store.getState().lightProfile.data.project.location.timezoneName,
								}
							}
						});
					console.log('lightProfileMiddleware', data);

					store.dispatch(fetchShortNumber({
						prefixLevels: ['CircularProfile', base, zone],
						data: data
					}));
				}

			}
		}
	}
	if (action.type === 'lightProfile/setZoneId') {
		store.dispatch(resetCustomUpload());
	}
	if (action.type === 'lightProfile/setBaseProfileId') {
		console.log('setBaseProfileId', action.payload.id);
		store.dispatch(resetCustomUpload());
		store.dispatch(setLuminaryId({id: null}));
		store.dispatch(closeSpcSession({instance: 'default'}));

	}
	if (action.type === 'spc/startSpcSession/fulfilled') {
		const lightProfile = store.getState().lightProfile.data;
		const region = store.getState().status.region;
		const spcSession = selectSpcSession(store.getState());
		let profileId = lightProfileToFeatureValueMap[lightProfile.project.base];

		// correct spelling error
		if (profileId === 'DynamicAmbience') {
			profileId = 'DynamicAmbiance';
		}

		// prepare decisions for lightProfile
		const initialDecisions = [
			spcExpliciteChoiceDecision('root::HS_CircularBaseProfile', profileId),
			spcExpliciteChoiceDecision('root::CX_Region', regionToFeatureValueMap[region] ?? 'int'),
			spcExpliciteChoiceDecision('root::EB_Control_1', 'CircularProfile'),
			spcExpliciteChoiceDecision('root::EB_ControlWire_1', 'CircularProfile'),
			spcExpliciteChoiceDecision('root::EB_ControlNoWire_1', 'NoDim'),
		];
		if (store.getState().status.productFamily === 'Avanza') {
			initialDecisions.push(spcExpliciteChoiceDecision('root::HS_HousingSize', 'Avanza450'));
		}
		console.log('lightProfile initial decisions', initialDecisions);
		await spcSession.makeManyDecisions(initialDecisions, {type: 'DropExistingDecisions', conflictHandling: {type: 'Automatic'}}).then(
			() => console.log('lightProfile initial decisions made'),
			error => console.error('lightProfile initial decisions failed', error)
		);
		/*
				await spcSession.makeDecision(
					spcExpliciteChoiceDecision('root::CX_Region', regionToFeatureValueMap[region] ?? 'int')
				);
				if (store.getState().status.productFamily === 'Avanza') {
					await spcSession.makeDecision(
						spcExpliciteChoiceDecision('root::HS_HousingSize', 'Avanza450')
					);
				}
				await spcSession.makeDecision(
					spcExpliciteChoiceDecision('root::HS_CircularBaseProfile', profileId)
				);
		 */
	}
	if (action.type === 'lightProfile/setLuminaryId') {
		if (action.payload.id !== null) {
			const lo = luminaryOptions.find(o => o.id === action.payload.id);
			await store.dispatch(
				setStatus({productFamily: lo.family})
			);
			await store.dispatch(
				setMode({mode: 'external'})
			);
		} else {
			await store.dispatch(
				setStatus({productFamily: null})
			);
		}
	}
	// copy dailySegments from profile to configuration
	if (action.type === 'lightProfile/fetchProfileResult/fulfilled') {
		console.log('lightProfile/fetchProfileResult/fulfilled', action.payload);
		await store.dispatch(
			saveLightProfileDailySegments(
				{dailySegments: store.getState().lightProfile.data.dailySegments}
			)
		);
	}
	return result;
};
